import Vue from 'vue'
import VueRouter from 'vue-router'
// eslint-disable-next-line no-unused-vars
import { verify, generateJwtToken } from '../plugins/middleware.js'

Vue.use(VueRouter)
const EmptyComponent = {
  template: '<router-view>No permission</router-view>',
}

const routes = [
  {
    path: '*',
    component: EmptyComponent,
  },
  {
    path: '/',
    name: 'Backend-Login',
    component: () => import('../backend/components/auth/auth.vue')
  },
  {
    path: '/admin/settings/greeting-point',
    name: 'Greeting-Point',
    component: () => import('../backend/components/greeting/greeting-point.vue')
  },
  {
    path: '/admin/settings/get-point-by-qr',
    name: 'Greeting-Point',
    component: () => import('../backend/components/qr-point/index.vue')
  },
  {
    path: '/admin/settings/point',
    name: 'Point',
    component: () => import('../backend/components/point/point.vue')
  },
  // {
  //   path: '/admin/settings/points',
  //   name: 'PointTab',
  //   component: () => import('../backend/components/point/point-tabs.vue')
  // },
  {
    path: '/admin/settings/rewards',
    name: 'Awards',
    component: () => import('../backend/components/rewards/rewards.vue')
  },
  {
    path: '/admin/settings/code',
    name: 'PointCode',
    component: () => import('../backend/components/point-code/point-code.vue')
  },
  {
    path: '/admin/users-management/roles',
    name: 'Roles',
    component: () => import('../backend/components/users-management/roles/roles.vue')
  },
  {
    path: '/admin/users-management/users',
    name: 'Users',
    component: () => import('../backend/components/users-management/users/users.vue')
  },
  {
    path: '/admin/users-management/permission',
    name: 'Permission',
    component: () => import('../backend/components/users-management/permission/permission.vue')
  },
  {
    path: '/admin/customers/customers-list',
    name: 'Customers',
    component: () => import('../backend/components/customers/customers.vue')
  },
  {
    path: '/admin/members/members-list',
    name: 'Members',
    component: () => import('../backend/components/members/members.vue')
  },
  {
    path: '/admin/members/adjust-point',
    name: 'Members',
    component: () => import('../backend/components/adjust-point/adjust-point.vue')
  },
  {
    path: '/admin/settings/category/:category-:name/subcategory',
    name: 'SubCategory',
    component: () => import('../backend/components/product-category/subcategory.vue')
  },
  {
    path: '/admin/settings/category',
    name: 'Category',
    component: () => import('../backend/components/product-category/category.vue')
  },

  {
    path: '/admin/settings/products',
    name: 'Products',
    component: () => import('../backend/components/products/products.vue')
  },
  {
    path: '/admin/settings/static-contents',
    name: 'เงื่อนไข/กติกา',
    meta: { code: "Contents" },
    component: () => import('../backend/components/contents/contents-tab.vue')
  },
  {
    path: '/admin/settings/terms',
    name: 'เงื่อนไขการใช้บริการ',
    meta: { code: "Terms" },
    component: () => import('../backend/components/contents/contents.vue')
  },
  {
    path: '/admin/settings/payment',
    name: 'การชำระเงิน',
    meta: { code: "Payment" },
    component: () => import('../backend/components/contents/contents.vue')
  },

  {
    path: '/admin/settings/line-link',
    name: 'Line-Link',
    component: () => import('../backend/components/line-link/line-link.vue')
  },

  //- setting privilege / point / tiers
  {
    path: '/admin/settings/point/value',
    name: 'PointValue',
    component: () => import('../backend/components/point-value/index.vue')
  },
  {
    path: '/admin/settings/point/expire',
    name: 'PointExpire',
    component: () => import('../backend/components/point-expire/index.vue')
  },
  // tiers
  {
    path: '/admin/settings/tier/expire',
    name: 'PointExpire',
    component: () => import('../backend/components/tier-expire/index.vue')
  },
  {
    path: '/admin/members/tiers-list',
    name: 'Tiers',
    component: () => import('../backend/components/tiers/tiers.vue')
  },
  {
    path: '/admin/members/privileges-list',
    name: 'Privileges',
    component: () => import('../backend/components/privileges/privileges.vue')
  },
   // Sale
  {
    path: '/admin/sales/sales-product',
    name: 'Sales',
    component: () => import('../backend/components/sale-products/sale-product.vue')
  },
   {
    path: '/admin/sales/sales-list',
    name: 'SalesList',
    component: () => import('../backend/components/sales/sales-list.vue')
  },
  // Redeem
  {
    path: '/admin/redeem/redeem-goods-list',
    name: 'RedeemGoods',
    component: () => import('../backend/components/redeem-list/redeem-goods-list.vue')
  },
  {
    path: '/admin/redeem/redeem-code-list',
    name: 'RedeemCode',
    component: () => import('../backend/components/redeem-list/redeem-code-list.vue')
  },
  {
    path: '/admin/redeem/redeem-privilege-list',
    name: 'RedeemPrivilege',
    component: () => import('../backend/components/redeem-privilege-list/redeem-privilege-list.vue')
  },
  {
    path: '/admin/redeem/qr',
    name: 'Redeem-QR',
    component: () => import('../backend/components/redeem/qr.vue')
  },
  {
    path: '/admin/redeem/lucky-draw',
    name: 'RedeemLuckyDraw',
    component: () => import('../backend/components/redeem/lucky-draw.vue')
  },

  {
    path: '/admin/redeem/redeem-pending',
    name: 'RedeemPending',
    component: () => import('../backend/components/redeem/redeem-pending.vue')
  },
  //redeem-privileges
  {
    path: '/admin/redeem-privilege/qr',
    name: 'Redeem-Privilege-QR',
    component: () => import('../backend/components/redeem-privilege/qr.vue')
  },

  //Profile
  {
    path: '/admin/profile',
    name: 'Profile',
    component: () => import('../backend/components/profile/profile.vue')
  },
  {
    path: '/password',
    name: 'Password',
    component: () => import('../backend/components/users-management/users/password.vue')
  },


  // auth
  {
    path: '/login',
    name: 'Login',
    component: () => import('../backend/components/auth/auth.vue')
  },

  // report
  {
    path: '/admin/dashboard',
    name: 'Dashboard',
    component: () => import('../backend/components/report/dashboard.vue')
  },
  {
    path: '/admin/report/point-flow',
    name: 'PointFlow',
    component: () => import('../backend/components/report/point-flow.vue')
  },
  {
    path: '/admin/report/money-flow',
    name: 'MoneyFlow',
    component: () => import('../backend/components/report/money-flow.vue')
  },
  {
    path: '/admin/report/member-report',
    name: 'MoneyReport',
    component: () => import('../backend/components/report/member-report.vue')
  },
  {
    path: '/admin/report/transactions',
    name: 'Transactions',
    component: () => import('../backend/components/report/transactions.vue')
  },
  {
    path: '/admin/report/point-summary-by-reward',
    name: 'PointSummaryByReward',
    component: () => import('../backend/components/report/point-summary-by-reward.vue')
  },
  {
    path: '/admin/report/collect-point',
    name: 'CollectPoint',
    component: () => import('../backend/components/report/collect-point.vue')
  },
  {
    path: '/admin/report/point-summary-by-product',
    name: 'PointSummaryByProduct',
    component: () => import('../backend/components/report/point-summary-by-product.vue')
  },
  //import
  {
    path: '/admin/import/sale-order',
    name: 'ImportSales',
    component: () => import('../backend/components/import/sale-order.vue')
  },




  // frontend
  {
    path: '/clients/',
    name: 'FrontendClient',
    component: () => import('../frontend/auth/login.vue')
  },
  {
    path: '/clients/redeem',
    name: 'Client-Redeem',
    component: () => import('../frontend/redeem/redeem.vue')
  },
  {
    path: '/clients/profile',
    name: 'Client-Profile',
    component: () => import('../frontend/profile/profile.vue')
  }
  ,
  {
    path: '/clients/rewards',
    name: 'Award',
    component: () => import('../frontend/award/award.vue')
  },


]

const router = new VueRouter({
  mode: 'history',
  routes
})
export default router
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page

  const publicPages = ['/login', '/'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = sessionStorage.getItem('user');
  const verified = verify(sessionStorage.getItem("token"), process.env.VUE_APP_ACCESS_TOKEN_SECRET)
  //console.log(verified)

  if (authRequired && !loggedIn && ! verified) {
    return next({
      path: '/login',
      query: {
        cusId: to.qeury,
      }
    });
  } else {

    next();
  }
})


